export default "__VITE_ASSET__8lscFgOs__"